import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';
import NewsletterUnsubscribe from '@ttstr/components/Customer/NewsletterUnsubscribe';

const UnsubscribeNewsletter: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  function handleUnsubscribe() {
    history.push('/newsletter/email_sent');
  }

  return (
    <article className="my-5">
      <Container>
        <Helmet>
          <title>{t(`NEWSLETTER.UNSUBSCRIBE.TITLE`)}</title>
        </Helmet>
        <h1 className="text-center mb-4">{t(`NEWSLETTER.UNSUBSCRIBE.TITLE`)}</h1>
        <Row>
          <Col lg={{ size: 6, offset: 3 }}>
            <p className="text-center">
              <strong>{t('NEWSLETTER.UNSUBSCRIBE.SUBTITLE')}</strong>
            </p>
            <p className="text-justify">{t('NEWSLETTER.UNSUBSCRIBE.DESCRIPTION')}</p>
            <NewsletterUnsubscribe onUnsubscribe={handleUnsubscribe} />
          </Col>
        </Row>
      </Container>
    </article>
  );
};

export default React.memo(UnsubscribeNewsletter);
